import { render, staticRenderFns } from "./cosDocOrderPay.vue?vue&type=template&id=60a2ef13&scoped=true"
import script from "./cosDocOrderPay.vue?vue&type=script&lang=js"
export * from "./cosDocOrderPay.vue?vue&type=script&lang=js"
import style0 from "./cosDocOrderPay.vue?vue&type=style&index=0&id=60a2ef13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a2ef13",
  null
  
)

export default component.exports